import styles from "../styles.module.css";

type Props = {
  title: string;
  value: any;
  setter: Function;
  hideAsterisk?: boolean;
  children: any;
};

const CampoSelect = ({
  title,
  value,
  setter,
  hideAsterisk,
  children,
}: Props) => {
  return (
    <div className={styles.campo}>
      <label>
        {title}
        <span className={styles.required}>{!hideAsterisk && "*"}</span>:
      </label>
      <select
        value={value}
        onChange={(e) => {
          const v = e.target.value;
          setter(v);
          e.currentTarget.setCustomValidity("");
        }}
      >
        {children}
      </select>
    </div>
  );
};

export default CampoSelect;
